var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.732 13.0896H3.26788C2.5741 13.0896 2.00586 12.5228 2.00586 11.8159V3.27367C2.00586 2.57349 2.56749 2 3.26788 2H11.732C12.4258 2 12.994 2.56682 12.994 3.27367V11.8159C12.9874 12.5228 12.4258 13.0896 11.732 13.0896Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7195 27H3.26202C2.56824 27 2 26.4331 2 25.7263V17.184C2 16.4838 2.56163 15.9103 3.26202 15.9103H11.7261C12.4199 15.9103 12.9882 16.4772 12.9882 17.184V25.7263C12.9816 26.4331 12.4199 27 11.7195 27Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7476 13.0896H17.2835C16.5897 13.0896 16.0215 12.5228 16.0215 11.8159V3.27367C16.0215 2.57349 16.5831 2 17.2835 2H25.7476C26.4414 2 27.0097 2.56682 27.0097 3.27367V11.8159C27.003 12.5228 26.4414 13.0896 25.7476 13.0896Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.734 27H17.2698C16.5761 27 16.0078 26.4331 16.0078 25.7263V17.184C16.0078 16.4838 16.5694 15.9103 17.2698 15.9103H25.734C26.4277 15.9103 26.996 16.4772 26.996 17.184V25.7263C26.996 26.4331 26.4277 27 25.734 27Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataView);
export default __webpack_public_path__ + "static/media/DataView.3ae61b76700996e7c9ddb91862163be9.svg";
export { ForwardRef as ReactComponent };